import React, { useState, useEffect } from "react";
import "../../Styles/ReportAll.css";
import Loader from "../../Components/Loader";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function FacultyReport() {
  const [issueType, setIssueType] = useState("");
  const [urgency, setUrgency] = useState("Medium");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        "https://api.uniums.com/api/reports/view-faculty-reports",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReports(response.data.reports);
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to fetch reports");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const token = localStorage.getItem("authToken");

    if (!issueType || !title || !description) {
      toast.error("Please fill all required fields.");
      setSubmitting(false);
      return;
    }

    const formData = new FormData();
    formData.append("issueType", issueType);
    formData.append("urgency", urgency);
    formData.append("title", title);
    formData.append("description", description);
    if (file) {
      formData.append("attachment", file);
    }

    try {
      await axios.post(
        "https://api.uniums.com/api/reports/faculty-reports",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Report submitted successfully!");
      setIssueType("");
      setUrgency("Medium");
      setTitle("");
      setDescription("");
      setFile(null);
      fetchReports();
    } catch (error) {
      console.error("Error submitting report:", error);
      toast.error("Failed to submit report");
    } finally {
      setSubmitting(false);
    }
  };

  // Function to check if the submit button should be enabled
  const isFormValid = issueType && title && description;

  return (
    <div className="repo-container">
      <ToastContainer />
      <h1>Faculty Report</h1>
      <form onSubmit={handleSubmit} className="repo-form">
        <label className="repo-label">
          Issue Type: <span>*</span>
        </label>
        <select
          className="repo-input"
          value={issueType}
          onChange={(e) => setIssueType(e.target.value)}
          required
        >
          <option value="">Select an issue</option>
          <option value="Admin">Admin</option>
          <option value="College">College</option>
          <option value="Classes">Classes</option>
          <option value="Student">Student</option>
        </select>

        <label className="repo-label">
          Urgency Level: <span>*</span>
        </label>
        <select
          className="repo-input"
          value={urgency}
          onChange={(e) => setUrgency(e.target.value)}
        >
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
          <option value="Critical">Critical</option>
        </select>

        <label className="repo-label">
          Report Title: <span>*</span>
        </label>
        <input
          type="text"
          className="repo-input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <label className="repo-label">
          Description: <span>*</span>
        </label>
        <textarea
          className="repo-textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Describe the issue..."
          required
        />

        <label className="repo-label">Upload Screenshot (optional):</label>
        <input
          type="file"
          className="repo-input"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <button
          type="submit"
          className="repo-button"
          disabled={!isFormValid || submitting}
        >
          {submitting ? <Loader /> : "Submit Report"}
        </button>
      </form>

      <h3 className="repo-subtitle">Report History</h3>
      {loading ? (
        <Loader />
      ) : (
        <div className="repo-list-table">
          <table className="repo-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Issue Type</th>
                <th>Urgency</th>
                <th>Issue Date</th>
                <th>Title</th>
                <th>Status</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{report.issueType}</td>
                  <td>{report.urgency}</td>
                  <td>
                      {new Date(report.createdAt).toLocaleDateString("en-GB")}
                    </td>
                  <td
                    style={{
                      padding: "10px",
                      minWidth: "200px",
                      maxWidth: "200px",
                      maxHeight: "200px",
                      overflow: "auto",
                      whiteSpace: "normal",
                    }}
                  >
                    {report.title}
                  </td>
                  <td>{report.status}</td>
                  <td
                    style={{
                      padding: "10px",
                      minWidth: "250px",
                      maxWidth: "200px",
                      maxHeight: "200px",
                      overflow: "auto",
                      whiteSpace: "normal",
                    }}
                  >
                    {report.remark ? report.remark : "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default FacultyReport;
